import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let maskSceneL: any = null,
    titleSceneL: any = null;
export default function L() {
    const { useLang, useRouter, useEffect, useState, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);
    const LOCAL_SITES: string[] = ['jp'];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (maskSceneL) {
                    AniContainer.removeScene(maskSceneL);
                    maskSceneL = null;
                }
                if (titleSceneL) {
                    AniContainer.removeScene(titleSceneL);
                    titleSceneL = null;
                }

                const pageHeight = window.innerHeight;
                const clientH = (pageHeight || 0) * 0.2;

                const startH = window?.innerWidth <= 1024 ? -(pageHeight * 0.5) : Math.min(clientH, 150);
                maskSceneL = AniContainer.create({
                    triggerElement: '.dpu-detail-L',
                    triggerHook: 0,
                    offset: startH,
                    duration: 200, //window.innerHeight * 2,
                    onEnter: () => {
                        setTextEnter(true);
                    },
                    //onLeave: () => setTextEnter(false),
                });
                // maskSceneL = AniContainer.create({
                //     asyncFromTo: [['.dpu-detail-L .mask', { opacity: 0 }, { opacity: 1 }]],
                //     triggerElement: '.dpu-detail-L',
                //     triggerHook: 1,
                //     offset: window.innerHeight,
                //     duration: window.innerHeight / 2,
                // });

                // titleSceneL = AniContainer.create({
                //     asyncFromTo: [['.dpu-detail-L .title', { opacity: 0, y: window.innerHeight / 4 }, { opacity: 1, y: 0 }]],
                //     triggerElement: '.dpu-detail-L',
                //     triggerHook: 1,
                //     offset: window.innerHeight * 1.5,
                //     duration: window.innerHeight / 2,
                // });
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (maskSceneL) {
                    AniContainer.removeScene(maskSceneL);
                    maskSceneL = null;
                }
                if (titleSceneL) {
                    AniContainer.removeScene(titleSceneL);
                    titleSceneL = null;
                }
                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section className={`dpu-detail-L dpu-detail-section ${css['dpu-detail-L']}`}>
            <div className={`sticky-box${textEnter ? ' textEnter' : ''}`}>
                <div className="img-box">
                    <EFPicture
                        src={`/responsive/picture/delta-pro-ultra/launch/12${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`}
                        srcPad={`/responsive/picture/delta-pro-ultra/launch/12_768${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`}
                        srcMobile={`/responsive/picture/delta-pro-ultra/launch/12_768${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`}
                        alt={t('secL_title')}
                    />
                    <div className="mask"></div>
                    <div className="title-box">
                        <h2 className="title">{t('secL_title')}</h2>
                    </div>
                </div>
            </div>
        </section>
    );
}
